import React, { useEffect } from 'react';
import { Box, Typography, Container, Button, Card, CardContent, CardActions, Grid } from '@mui/material';
import { PictureAsPdf as PictureAsPdfIcon, TrendingUp as TechIcon } from '@mui/icons-material';

const Tools = () => {
  useEffect(() => {
    document.title = "Generic Utility Tools | CoreTechTalks";
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute("content", "Explore our utility tools at CoreTechTalks — networth tracking, PDF toolkit, and more.");
    }
  }, []);

  return (
    <Box sx={{ flexGrow: 1, py: { xs: 8, md: 10 }, minHeight: 'calc(100vh - 200px)', display: 'flex', alignItems: 'center' }}>
      <Container maxWidth="lg">
        {/* Header Section */}
        <Box textAlign="center" mb={6}>
          <Typography 
            variant="h1" 
            component="h1" 
            sx={{ fontWeight: 800, mb: 2, fontSize: { xs: '36px', md: '48px' } }}
          >
            Generic <span className="gradient-text">Utility Tools</span>
          </Typography>
          <Typography 
            variant="h6" 
            color="text.secondary"
            sx={{ mb: 6, maxWidth: '600px', mx: 'auto', fontWeight: 500 }}
          >
            Explore our collection of AI-powered utility tools.
          </Typography>
        </Box>

        <Grid container spacing={4}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Card
              sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                p: 2,
                alignItems: 'center',
                textAlign: 'center'
              }}
            >
              <CardContent sx={{ flexGrow: 1, p: 3 }}>
                <Box 
                  sx={{ 
                    display: 'inline-flex',
                    p: 1.5,
                    borderRadius: '12px',
                    bgcolor: 'rgba(99, 102, 241, 0.08)',
                    color: 'primary.main',
                    mb: 3
                  }}
                >
                  <TechIcon sx={{ fontSize: '32px' }} />
                </Box>

                <Typography variant="h5" component="h2" gutterBottom fontWeight="800" sx={{ mb: 1.5 }}>
                  See Your Networth
                </Typography>
                <Typography color="text.secondary" variant="body2" sx={{ lineHeight: 1.6 }}>
                  Track your investments, liabilities, and monthly expenses. Project your net worth and compound growth up to 40 years into the future with a private, secure dashboard.
                </Typography>
              </CardContent>
              
              <CardActions sx={{ p: 3, pt: 0, width: '100%' }}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  href="https://www.seeyournetworth.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ py: 1.2 }}
                >
                  Launch Application
                </Button>
              </CardActions>
            </Card>
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <Card
              sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                p: 2,
                alignItems: 'center',
                textAlign: 'center'
              }}
            >
              <CardContent sx={{ flexGrow: 1, p: 3 }}>
                <Box 
                  sx={{ 
                    display: 'inline-flex',
                    p: 1.5,
                    borderRadius: '12px',
                    bgcolor: 'rgba(99, 102, 241, 0.08)',
                    color: 'primary.main',
                    mb: 3
                  }}
                >
                  <PictureAsPdfIcon sx={{ fontSize: '32px' }} />
                </Box>

                <Typography variant="h5" component="h2" gutterBottom fontWeight="800" sx={{ mb: 1.5 }}>
                  PDF Toolkit
                </Typography>
                <Typography color="text.secondary" variant="body2" sx={{ lineHeight: 1.6 }}>
                  A comprehensive toolkit for merging, splitting, compressing, and managing your PDF documents.
                </Typography>
              </CardContent>
              
              <CardActions sx={{ p: 3, pt: 0, width: '100%' }}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  href="https://pdfprokit.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ py: 1.2 }}
                >
                  Launch Application
                </Button>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Tools;